import { Box, Flex } from "@chakra-ui/react"
import { useQRCode } from "next-qrcode"
import CustomImage from "../../../../shared/CustomImage"

type Props = {
  imageSrc: string
  imgAlt?: string
  url: string
}

const QRelement = ({ imageSrc, imgAlt = "App store logo", url }: Props) => {
  const { SVG } = useQRCode()

  return (
    <Flex flexDirection="column" gap="4">
      <Box h="11" as="a" href={url}>
        <CustomImage src={imageSrc} w="100%" h="100%" alt={imgAlt} />
      </Box>

      <Box display={{ base: "none", md: "block" }}>
        <SVG text={url} options={{ margin: 0, width: 120 }} />
      </Box>
    </Flex>
  )
}

export default QRelement
